module.exports = __webpack_public_path__ + "img/16_105.1b0a0b84.png";